import { UploadFile } from 'antd';

export const getFileDigest = async (file: File) => {
  try {
    const arrayBuffer = await file.arrayBuffer();

    const hashBuffer = await crypto.subtle.digest('SHA-256', arrayBuffer);
    const hashArray = Array.from(new Uint8Array(hashBuffer));

    return hashArray.map(hash => hash.toString(16).padStart(2, '0')).join('');
  } catch (error) {
    throw new Error('cannot read file');
  }
};

export const getBase64 = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = error => reject(error);
  });
};

export const spliceBase64 = (base64: string) => {
  return base64.split(',')[1];
};

export const maxFileListSizeLimitValidatorRule =
  (limit: number) => (rule: unknown, fileList: Array<UploadFile<unknown>>) => {
    const totalSize = (fileList || []).map(file => file.size).reduce((a = 0, b = 0) => a + b, 0) || 0;

    if (totalSize >= limit) {
      return Promise.reject('File limit reached');
    }

    return Promise.resolve();
  };
